const jquery = require('jquery');

const loadMore = function loadMore() {
  const loadMoreSection = document.querySelectorAll('.js-load-more');

  if (loadMoreSection.length < 1) return false;

  loadMoreSection.forEach(el => {
    const button = el.querySelector('.btn.load-more a');
    const container = el.querySelector('.ajax-append');

    if (button && container) {
      let paged = 1;
      button.addEventListener('click', e => {
        e.preventDefault();
        jquery(button).addClass('loading');

        const params = JSON.parse(e.target.attributes.getNamedItem('data-request').value);

        paged = paged + 1;

        jquery.ajax(params.url, {
          data: {
            action: params.action,
            pagination: paged,
            posts_per_page: ('posts_per_page' in params) ? params.posts_per_page : false,
            type: params.type,
            taxonomy_terms: params.taxonomy_terms,
            exclude: ('exclude' in params) ? params.exclude : false,
          },
          success(response, status) {
            if (! response.success) return;
            jquery(button).removeClass('loading');

            if (! response.data.more_posts_available || !response.data == 'no-more-posts') {

              jquery(button).addClass('deactive');

              if (!response.data == 'no-more-posts') {
                return;
              }

            }

            let $content = jquery.parseHTML(response.data.posts);
            $content = $content.filter(item => item.nodeName !== '#text');
            $content = jquery($content);

            $content.addClass('appended');

            jquery(container).append($content);
            $content.each(function(index) {
              jquery(this).css({
                transitionDelay: index * 0.3 + 's',
              });
            });

            window.requestAnimationFrame(() => {
              $content.addClass('loaded');
            });

            jquery(document.body).trigger('post-load');

          },
        });
      });

    }
  });
};

module.exports = loadMore;
